import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import NavBar from './components/layout/NavBar';
import LandingPage from './components/LandingPage';
import StoryList from './components/StoryList';
import StoryCreator from './components/StoryCreator';
import StoryPlayer from './components/StoryPlayer';
import StoryEditor from './components/editor/StoryEditor';
import StoryPreview from './components/editor/StoryPreview';
import ProfilePage from './components/ProfilePage';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ProtectedRoute from './components/ProtectedRoute';
import SharedStoryViewer from './components/SharedStoryViewer';
import { useAuth } from './context/AuthContext';
import './App.css';

function AppContent() {
  const { user } = useAuth();

  return (
    <div className="app-container min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-mint-50 p-4">
      <div className="max-w-6xl mx-auto">
        {/* Only show NavBar if user is logged in or on specific routes */}
        {user && <NavBar />}
        
        <Routes>
          {/* Public routes */}
          <Route path="/welcome" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/shared/:shareId" element={<SharedStoryViewer />} />

          {/* Root route - show landing page if not logged in, dashboard if logged in */}
          <Route 
            path="/" 
            element={
              user ? <StoryList /> : <Navigate to="/welcome" replace />
            } 
          />

          {/* Profile completion route */}
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } 
          />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/create" element={<StoryCreator />} />
            <Route path="/story/:id/play" element={<StoryPlayer />} />
            <Route path="/story/:id/edit" element={<StoryEditor />} />
            <Route path="/story/:id/preview" element={<StoryPreview />} />
          </Route>

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;